import React, { useState } from "react";

import { Button, Stack } from "@mui/material";
import { InvestorAutocomplete } from "components/Autocompletes/InvestorAutocomplete";

type InvestorOption = { id: number; name: string };

interface Props {
  currentInvestorId: number | null;
  dealInvestors: InvestorOption[];
  loading?: boolean;
  onSubmit: (result: { investor: InvestorOption | null }) => void;
  onCancel: () => void;
}

export const InvestorSelectPrompt: React.FC<Props> = ({
  currentInvestorId,
  dealInvestors,
  loading,
  onSubmit,
  onCancel
}) => {
  const [selected, setSelected] = useState<InvestorOption | null>(
    dealInvestors.find((inv) => inv.id === currentInvestorId) ?? null
  );

  return (
    <Stack sx={{ padding: "24px", gap: "20px", minWidth: "427px" }}>
      <InvestorAutocomplete
        label="Investor"
        loading={loading}
        dealInvestors={dealInvestors}
        preselectedInvestorId={selected?.id ?? null}
        onChange={(value) => setSelected(value)}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "8px",
            "& fieldset": { borderColor: "#7b92a9" }
          }
        }}
      />
      <Stack direction="row" justifyContent="flex-end" gap="8px">
        <Button
          onClick={onCancel}
          sx={{
            borderRadius: "32px",
            border: "1px solid #7b92a9",
            color: "#071f35",
            textTransform: "none",
            padding: "4px 16px",
            fontSize: "16px",
            fontWeight: 400,
            lineHeight: "24px"
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={() => onSubmit({ investor: selected })}
          sx={{
            borderRadius: "32px",
            bgcolor: "#071f35",
            color: "white",
            textTransform: "none",
            padding: "4px 16px",
            fontSize: "16px",
            fontWeight: 400,
            lineHeight: "24px",
            "&:hover": { bgcolor: "#0a2a45" },
            "&:disabled": { bgcolor: "#bac7ce", color: "white" }
          }}
        >
          Add
        </Button>
      </Stack>
    </Stack>
  );
};
